module.exports = __webpack_public_path__ + "img/profession.e0bc80b1.png";